// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectNewsSubscribeResponseMessage } from '@shared/utils/DirectMessages/DirectNewsSubscribeResponseMessage';
import { SubscribeNewsGroup } from '../Groups/GroupsImport';
export class NewsSubscribeResponseProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectNewsSubscribeResponseMessage();
        const subscribeNewsGroups = fieldSet.GetGroups(FieldsFactory.SUBSCRIBE_NEWS_GROUP);
        if (subscribeNewsGroups) {
            for (let i = 0; i < subscribeNewsGroups.length; i++) {
                const subscribeNewsGroupFieldSet = subscribeNewsGroups[i];
                const subscribeNewsGroup = new SubscribeNewsGroup(subscribeNewsGroupFieldSet);
                const routeID = subscribeNewsGroup.getRouteId();
                if (routeID) {
                    message.RouteIdsArr.push(routeID);
                }
            }
        }
        return [message];
    }
}
